import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { addPtoData, addPtoDataFailure, addPtoDataSuccess, addPtoRejectedData, addPtoRejectedDataFailure, addPtoRejectedDataSuccess, cancelPtoRecord, cancelPtoRecordFailure, cancelPtoRecordSuccess, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createPtoCommentRecord, createPtoCommentRecordFailure, createPtoCommentRecordSuccess, editPtoData, editPtoDataFailure, editPtoDataSuccess, fetchPtoAttachments, fetchPtoAttachmentsFailure, fetchPtoAttachmentsSuccess, fetchPtoCancelReasonsList, fetchPtoCancelReasonsListFailure, fetchPtoCancelReasonsListSuccess, fetchPtoFileAttachment, fetchPtoFileAttachmentFailure, fetchPtoFileAttachmentSuccess, fetchPtoListData, fetchPtoListFailure, fetchPtoListSuccess, fetchPtoMembersList, fetchPtoMembersListFailure, fetchPtoMembersListSuccess, fetchPtoRecordComments, fetchPtoRecordCommentsFailure, fetchPtoRecordCommentsSuccess, fetchPtoRecordholdunhold, fetchPtoRecordholdunholdFailure, fetchPtoRecordholdunholdSuccess, fetchPtoRejectedListData, fetchPtoRejectedListDataFailure, fetchPtoRejectedListDataSuccess, fetchSinglePtoRecordData, fetchSinglePtoRecordDataFailure, fetchSinglePtoRecordDataSuccess, releasePtoRecord, releasePtoRecordFailure, releasePtoRecordSuccess, updatePtoStatus, updatePtoStatusFailure, updatePtoStatusSuccess } from "./pto.actions";
import { catchError, from, map, mergeMap, of, switchMap, tap } from "rxjs";
import { TokenStorageService } from "../../core/services/token-storage.service";
import { GenericService } from "../../core/services/generic.service";
import { and, collection, collectionData, or, orderBy, query, QueryCompositeFilterConstraint, where } from "@angular/fire/firestore";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { PtoService } from "../../core/services/pto.service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { ToastifyService } from "../../shared/toastify-service";
import { GlobalComponent } from "../../global-component";
import { FiltersService } from "../../core/services/filters.service";

@Injectable()
export class PtoEffects{
    currentuser: any;
    firbasebasecollname: string = 'vendors';
    subdomaincollname: string = 'subdomains';
    vendorguid!: string;
    isdataoperator = false;

    constructor(
        private actions$: Actions, 
        private tokenService: TokenStorageService,
        private genericService: GenericService,
        private afs: AngularFirestore,
        private ptoservice: PtoService,
        private commonService: CommonAPIService,
        private toastifyService: ToastifyService,
        private filtersService: FiltersService
    ) {}

    // check condition
    async checkCondition(tabId: number) {
        console.log("--inside check condition--", tabId);
        this.currentuser = this.tokenService.getUser();
        this.isdataoperator = this.currentuser.isdataoperator;
        console.log("--current user inside check condition--", this.currentuser)
        const isuservendor = this.genericService.getUserIsVendor();
        const vendorCollection = collection(this.afs.firestore, `${this.firbasebasecollname}/${this.tokenService.getVendorGUID()!}/ptos`);
        console.log("---vendorCollection Line 30---", vendorCollection);
        let activestateval = true;
        if (tabId == 5) {
            activestateval = false;
        }

        let baseQuery = and(where('activestate', '==', activestateval));

        const filterData: any = this.filtersService.getPtoSelectedFilters()

        // Adding Filter Queries to baseQuery
    if (filterData.clients && filterData.clients.length) {
        baseQuery = and(baseQuery, where("clientguid", 'in', filterData.clients))
        }
        
        if (filterData.states && filterData.states.length) {
            baseQuery = and(baseQuery, where("state", "in", filterData.states))
        }
        
        
        if (filterData.statuses && filterData.statuses.length) {
            baseQuery = and(baseQuery, where("jobstatus", "in", filterData.statuses))
        }
        
        if (filterData.daterange && filterData.daterange.length) {
            let queryby = ""
            switch (tabId) {
              case 1:
                queryby = "createdAt"
                break
              case 2:
                queryby = "onholddate"
                break
              case 4:
                queryby = "deliverydate"
                break
              default:
                queryby = "createdAt"
            }
            let startDate = new Date(filterData.daterange[0].setHours(0, 0, 0, 0))
            let endDate = new Date(filterData.daterange[0].setHours(23, 59, 59, 999))
            console.log(startDate, endDate)
            if (filterData.daterange.length === 2) {
              endDate = new Date(filterData.daterange[1].setHours(23, 59, 59, 999))
            }
      
            baseQuery = and(baseQuery, where(queryby, ">=", startDate.toISOString()), where(queryby, "<=", endDate.toISOString()))
          }
      



        const userRoleCondition = where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
        let userRoleQuery: any = baseQuery;
        let memberQuery: QueryCompositeFilterConstraint | null = null;

        console.log("condition test 1", !this.currentuser.usertype || !isuservendor, isuservendor, this.currentuser)
        if (!this.currentuser.usertype || !isuservendor) {
            userRoleQuery = and(userRoleCondition, where('activestate', '==', activestateval)) as QueryCompositeFilterConstraint;
        }

        switch (tabId) {
            case 1:
                if (!isuservendor) {
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked', 'interconnectionrejected']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));
                }

                if(this.currentuser.isdataoperator){
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['accepted', 'interconnectioncompleted', 'interconnectionrejected']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));
                }

                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['outsourced', 'accepted', 'picked', 'interconnectionrejected']), where('isinrevisionstate', '==', false)), orderBy("createdAt", "desc"));

            case 2:
                return query(vendorCollection, and(userRoleQuery, where('jobstatus', '==', 'hold')), orderBy("onholdate", "desc"));

            case 3:
                if(this.currentuser.isdataoperator){
                    return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', false), where('jobstatus', 'in', ['interconnectioninprogress', 'ptoinprogress', 'ptorejected']), where('activeuserguid', '==', this.currentuser.guid)), orderBy("createdAt", "desc"));
                }

                return query(vendorCollection, and(userRoleQuery, where('isinrevisionstate', '==', false), where('jobstatus', 'in', ['interconnectioninprogress', 'ptoinprogress', 'interconnectioncompleted', 'ptorejected'])), orderBy("createdAt", "desc"));

            case 4:
                // Delivered list - To be done - indexing required - activeuserguid will be changed to respective userguid
                // if(this.currentuser.isdataoperator) {
                //     return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false), where('activeuserguid', '==', this.currentuser.guid))), orderBy("deliverydate", "desc"));
                // }
                return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false))), orderBy("deliverydate", "desc"));

            case 5:
                return query(vendorCollection, userRoleQuery, orderBy("cancelleddate", "desc"));

            default:
                console.log('Invalid tabId:', tabId);
                return query(vendorCollection, baseQuery, orderBy("createdAt", "desc"));
        }
    }

    // Pto List Effect Of Vendor
    // {
    // const collectionRef = collection(this.afs.firestore, `ptos/${tabId}/data`);
    // return collectionData<PtoModel>(collectionRef).pipe(
    //     map((docs) => {
    //         console.log("docs", docs);
    //         console.log("tabId", tabId);
    //         return fetchPtoListSuccess({ Pto: docs, tabId });
    //     }),
    //     catchError((error) =>
    //         of(fetchPtoListFailure({ error: error.message, tabId }))
    //     )
    // );
    // }

    // Create Pto Record
    addPtoData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addPtoData),
            mergeMap(({ postdata }) =>
                this.ptoservice.addPtoData(postdata).pipe(
                    map((Ptorecord) => addPtoDataSuccess(Ptorecord)),
                    catchError((error) => of(addPtoDataFailure({ error })))
                )
            ),
        ),
    );

    addPtoDataSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addPtoDataSuccess),
                tap((user: any) => {
                    this.toastifyService.showSuccessMessage("Order created successfully");
                })
            ),
        { dispatch: false }
    );

    addPtoDataFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addPtoDataFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // // Fetching ptos from firebase
    // fetchPtoData$ = createEffect(() =>
    //     this.actions$.pipe(
    //       ofType(fetchPtoListData),
    //       mergeMap(({ tabId }) =>
    //         from(this.checkCondition(tabId)).pipe(
    //           mergeMap(condition =>
    //             collectionData(condition).pipe(
    //               map((docs: any) => {
    //                 console.log("docs", docs);
    //                 console.log("tabId", tabId);
    //                 const ptos = docs.map((doc: PtoModel) => doc);
    //                 return fetchPtoListSuccess({ Ptos: ptos, tabid: tabId });
    //               }),
    //               catchError((error) =>
    //                 of(fetchPtoListFailure({ error, tabid: tabId }))
    //               )
    //             )
    //           )
    //         )
    //       )
    //     )
    //   );

    // Refetch when the condition changes
fetchPtoData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPtoListData),
      switchMap(({ tabId }) => 
        from(this.checkCondition(tabId)).pipe(
          switchMap(condition =>
            collectionData(condition).pipe(
              map((docs: any) => fetchPtoListSuccess({ Ptos: docs, tabid: tabId })),
              catchError((error) => of(fetchPtoListFailure({ error, tabid: tabId })))
            )
          )
        )
      )
    )
  );

    // Fetching and updating ptos status
    updatePtoStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updatePtoStatus),
            mergeMap(({ recordguid, postdata }) =>
                this.ptoservice.updatePtoStatus(recordguid, postdata).pipe(
                    map(() => updatePtoStatusSuccess()),
                    catchError((error) => of(updatePtoStatusFailure({ error })))
                )
            ),
        ),
    );

    // Fetch pto record
    fetchSinglePtoRecordData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSinglePtoRecordData),
            mergeMap(({ recordguid }) =>
                this.ptoservice.getSinglePtoRecordData(recordguid).pipe(
                    map((ptorecord) => fetchSinglePtoRecordDataSuccess({ ptorecord })),
                    catchError((error) => of(fetchSinglePtoRecordDataFailure({ error })))
                )
            ),
        ),
    );

    // Comment create
    createPtoCommentRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createPtoCommentRecord),
            mergeMap(({ postdata }) =>
                this.commonService.createRecords('ptocomments', postdata).pipe(
                    map((comment) => createPtoCommentRecordSuccess({ comment })),
                    catchError((error) => of(createPtoCommentRecordFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Pto Comments Record
    fetchPtoRecordComments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPtoRecordComments),
            mergeMap(({ recordguid }) =>
                this.commonService.fetchRecords('ptocomments', recordguid, 'createdAt:DESC').pipe(
                    map((comments) => fetchPtoRecordCommentsSuccess({ comments: comments })),
                    catchError((error) => of(fetchPtoRecordCommentsFailure({ error })))
                )
            ),
        ),
    );

    fetchPtoRecordCommentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPtoRecordCommentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Fetch Pto Comments Record
    fetchPtoMembersList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPtoMembersList),
            mergeMap(({ recordguid }) =>
                this.ptoservice.getPtosMembersList(recordguid).pipe(
                    map((list) => fetchPtoMembersListSuccess({ memberslist: list })),
                    catchError((error) => of(fetchPtoMembersListFailure({ error })))
                )
            ),
        ),
    );

    fetchPtoMembersListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPtoMembersListFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // HOLD RECORD CREATE
    createHoldRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createHoldRecord),
            mergeMap(({ postdata }) =>
                this.commonService.createRecords('ptoholdjobs', postdata).pipe(
                    map((holdrecord: any) => createHoldRecordSuccess({ holdrecord })),
                    catchError((error) => of(createHoldRecordFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Pto Hold/Unhold Record
    fetchPtoRecordholdunhold$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPtoRecordholdunhold),
            mergeMap(({ recordguid }) =>
                this.commonService.fetchRecords('ptoholdjobs', recordguid, 'createdAt:DESC').pipe(
                    map((holdunholdrecords) => fetchPtoRecordholdunholdSuccess({ holdunhold: holdunholdrecords })),
                    catchError((error) => of(fetchPtoRecordholdunholdFailure({ error })))
                )
            ),
        ),
    );

    // FETCH ATTACHMENTS OF Pto RECORD
    fetchPtoAttachments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPtoAttachments),
            mergeMap(({ jobguid }) =>
                this.ptoservice.getPtosAttachments(jobguid).pipe(
                    map((attachments) => fetchPtoAttachmentsSuccess({ attachments })),
                    catchError((error) => of(fetchPtoAttachmentsFailure({ error })))
                )
            ),
        ),
    );

    fetchPtoAttachmentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPtoAttachmentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // CANCEL PTO PROJECT
    cancelPtoRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(cancelPtoRecord),
            mergeMap(({ postdata }) =>
                this.ptoservice.cancelPtoProject(postdata).pipe(
                    map(() => cancelPtoRecordSuccess()),
                    catchError((error) => of(cancelPtoRecordFailure({ error })))
                )
            ),
        ),
    );

    cancelPtoRecordSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(cancelPtoRecordSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage(GlobalComponent.messages.cancelsuccess);
                })
            ),
        { dispatch: false }
    );

    cancelPtoRecordFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(cancelPtoRecordFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH CANCEL REASONS FROM FIREBASE
    fetchPtoCancelReasonsList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPtoCancelReasonsList),
            mergeMap(() =>
                this.afs.collection(GlobalComponent.firebasecancelreasonsbasecollname).doc('JnlKZBhKuN2yOmSiptTb')
                    .valueChanges().pipe(
                        map((docs: any) => {
                            console.log(":docs", docs)
                            return fetchPtoCancelReasonsListSuccess({ reasons: docs });
                        }),
                        catchError((error) =>
                            of(fetchPtoCancelReasonsListFailure({ error }))
                        )
                    )
            ),
        ),
    );

    fetchPtoCancelReasonsListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchPtoCancelReasonsListFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
                })
            ),
        { dispatch: false }
    );

    /**
   * RELEASE PLANSET RECORD
   */
    releasePtoRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(releasePtoRecord),
            mergeMap(({ recordguid, postdata }) =>
                this.ptoservice.releaserecord(recordguid, postdata).pipe(
                    map(() => releasePtoRecordSuccess()),
                    catchError((error) => of(releasePtoRecordFailure({ error })))
                )
            ),
        ),
    );

    releasePtoRecordSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(releasePtoRecordSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Record released successfully");
                    // this.router.navigate(['../']);
                })
            ),
        { dispatch: false }
    );

    releasePtoRecordFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(releasePtoRecordFailure),
                tap((error: any) => {
                    console.log('error', error);
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Edit Pto Record
    editPtoData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(editPtoData),
            mergeMap(({ postdata, recordId }) =>
                this.ptoservice.editPtoData(postdata, recordId).pipe(
                    map((Ptorecord) => editPtoDataSuccess(Ptorecord)),
                    catchError((error) => of(editPtoDataFailure({ error })))
                )
            ),
        ),
    );

    editPtoDataSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editPtoDataSuccess),
                tap((user: any) => {
                    this.toastifyService.showSuccessMessage("Order updated successfully");
                })
            ),
        { dispatch: false }
    );

    editPtoDataFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editPtoDataFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH ATTACHMENTS OF PTO RECORD
  fetchPtoFileAttachment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPtoFileAttachment),
      mergeMap(({ jobguid }) =>
        this.ptoservice.getPtoFile(jobguid).pipe(
          map((attachments) => fetchPtoFileAttachmentSuccess({ attachments })),
          catchError((error) => of(fetchPtoFileAttachmentFailure({ error })))
        )
      ),
    ),
  );

  fetchPtoFileAttachmentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchPtoFileAttachmentFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
    );
    

    // Add Pto Rejected Record
    addPtoRejectedData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addPtoRejectedData),
            mergeMap(({ postdata }) =>
                this.ptoservice.addPtoRejectedRecord(postdata).pipe(
                    map((record) => addPtoRejectedDataSuccess({ record })),
                    catchError((error) => of(addPtoRejectedDataFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Pto Rejected List
    fetchPtoRejectedListData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchPtoRejectedListData),
            mergeMap(({ postdata }) =>
                this.ptoservice.getRejectedList(postdata).pipe(
                    map((rejectedlist) => fetchPtoRejectedListDataSuccess({ rejectedlist })),
                    catchError((error) => of(fetchPtoRejectedListDataFailure({ error })))
                )
            ),
        ),
    );
 
}
